import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasAlhaurin() {
  return (
    <CityPagePersianas
      name="Alhaurín de la Torre"
      slug="alhaurin-de-la-torre"
      cp="29130"
      poblacion={44000}
      zonaGeo="Guadalhorce"
      lat={36.6635}
      lng={-4.5582}
      zonas={[
        "Centro Alhaurín",
        "El Romeral",
        "Pinos de Alhaurín",
        "Taralpe",
        "Retamar",
      ]}
      landmarks={[
        "Plaza Mayor",
        "Parque Municipal",
        "Cerro del Júpiter",
      ]}
      municipiosLimitrofes={[
        "Málaga",
        "Torremolinos",
        "Alhaurín el Grande",
        "Cártama",
        "Mijas",
      ]}
      festivalLocal="Feria de Alhaurín, primera semana de septiembre"
      contextoTipologico="Municipio en crecimiento rápido cerca de Málaga, urbanizaciones residenciales modernas, demanda toldos para chalets."
      isCoreZone={false}
    />
  );
}